import React from "react";
import Table from "../../common/Table";
import { NavWrap, TableWrap } from "../ShopForTyres";


const Claims = () => {
  const columns = [
    {
      header: "Claim ID",
      accessor: "claimId",
      width: 17,
    },
    {
      header: "Claim Type",
      accessor: "claimType",
      width: 17,
    },
    {
      header: "Claim Date",
      accessor: "claim_date",
      width: 17,
    },
    {
      header: "Invoice No",
      accessor: "inovice_no",
      width: 17,
    },
    {
      header: "Quantity",
      accessor: "quantity",
      width: 17,
    },

    {
      header: "Status",
      accessor: "status",
      width: 15,
      className: "psa_status",
      cell: (row) => <span className="text-btn">{row.status}</span>,
    },
  ];

  const data = [
    {
      claimId: "0110001036",
      claimType: "0110001036",
      quantity: "234",

      inovice_no: "0110001036",
      claim_date: "9 Sep' 20",
      status: "Pending",
    },
    {
      claimId: "0110001036",
      claimType: "0110001036",
      quantity: "234",

      inovice_no: "0110001036",
      claim_date: "9 Sep' 20",
      status: "Pending",
    },
    {
      claimId: "0110001036",
      claimType: "0110001036",
      quantity: "234",

      inovice_no: "0110001036",
      claim_date: "9 Sep' 20",
      status: "Pending",
    },
  ];

  return (
    <div className="shop-tyres">
      <NavWrap>
        <TableWrap
          isFilter={false}
          showBulk={false}
          name={"Claims"}
          showGrid={false}
          searchPlaceholder={"Search by order id..."}
          namedFilters={["All (27)", "Open (12)", "Pending (14)", "Paid (1)"]}
          createBtn={true}
          createText={"New Claim"}
          to={"/new-claim"}
        >
          <Table columns={columns} data={data} action={false} actionWidth={8} />
        </TableWrap>
      </NavWrap>
    </div>
  );
};

export default Claims;
